import React, { useContext, useEffect, useState } from "react";
import { Box, Button, Grid, Paper, TextField, Typography } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from "dayjs";
import makeStyles from "@mui/styles/makeStyles";
import { postDataWithToken } from "../../services/PostDataService";
import { useSnackbar } from "notistack";
import { AuthContext } from "../../context/AuthContext";
import PulseLoader from "react-spinners/PulseLoader";
import { useTheme } from "@mui/material/styles";
const useStyles = makeStyles((theme) => ({
  flipCard: {
    backgroundColor: "transparent",
    maxWidth: "500px",
    // minHeight: "350px",
    height: "300px",
    // height: "100%",
    perspective: 1000,
    cursor: "pointer",
    margin: "auto",
    borderRadius: "24px",
  },
  flipCardInner: {
    position: "relative",
    borderRadius: "24px",
    width: "100%",
    height: "100%",
    // textAlign: "center",
    transition: "transform 0.6s",
    transformStyle: "preserve-3d",
    // boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    "&:hover": {
      transform: "rotateY(-180deg)",
    },
  },
  flipCardFront: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "24px",
    WebkitBackfaceVisibility: "hidden",
    backfaceVisibility: "hidden",
    backgroundColor: "#24293E",
    color: "#fff",
  },
  flipCardBack: {
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "24px",
    WebkitBackfaceVisibility: "hidden",
    backfaceVisibility: "hidden",
    backgroundColor: "#24293E",
    color: "#fff",
    transform: "rotateY(180deg)",
  },
}));

const AddCard = ({ handleAddCardClose, getCardList }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { login, admin_panel_user, logout } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
  const [isFlipped, setIsFlipped] = useState(false);
  const [cardNo, setCardNo] = useState("");
  const [cardCVC, setCardCVC] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [cardHolderEmail, setCardHolderEmail] = useState("");
  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === "error") {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const clearForm = () => {
    setCardHolderName("");
    setCardHolderEmail("");
    setCardNo("");
    setDate(null);
    setCardCVC("");
  };
  const check = () => {
    console.log("date", date);
    console.log("month", date.$y);
    console.log("year", date.$M + 1);
    // console.log("currentDate.getFullYear();", date.getFullYear());
  };

  const handleCardClick = () => {
    setIsFlipped(!isFlipped);
  };
  const handleDate = (event) => {
    let inputText = event.target.value;

    // Remove non-digit characters
    inputText = inputText.replace(/[^\d]/g, "");

    // Format the input as "mm/yy"
    const formattedValue =
      inputText.length >= 2
        ? `${inputText.slice(0, 2)}/${inputText.slice(2, 4)}`
        : inputText;

    setDate(formattedValue);
  };
  const formatCardNumber = (number) => {
    // Remove non-digit characters
    if (cardNo.length > 0 && !isNaN(cardNo)) {
      const cleanedNumber = cardNo.replace(/\D/g, "");

      // Insert two spaces after every 4 digits
      const formattedNumber = cleanedNumber.replace(/(\d{4})(?=\d)/g, "$1  ");

      return formattedNumber.trim(); // Remove leading/trailing spaces
    }
    return "0000 0000 0000 0000";
  };
  const formatCardCVCNumber = (number) => {
    // Remove non-digit characters
    if (cardCVC.length > 0 && !isNaN(cardCVC)) {
      return cardCVC; // Remove leading/trailing spaces
    }
    return "000";
  };
  const validation = () => {
    let isError = false;

    if (isNaN(date.$y) || isNaN(date.$M + 1)) {
      handleSnakbarOpen("Please enter valid expiration date", "error");
      document.getElementById("date").focus();
      return (isError = true);
    }
    return isError;
  };
  const handleAddNewCard = async (e) => {
    e.preventDefault();

    let err = validation();
    if (err) {
      return;
    } else {
      setLoading(true);

      let data = {
        storeId: admin_panel_user.selectedStoreId,
        cardNum: cardNo,
        cardExpMonth: date.$M + 1,
        cardExpYear: date.$y,
        cardCVC: cardCVC,
        cardHolderName: cardHolderName,
        cardHolderEmail: cardHolderEmail,
      };

      let response = await postDataWithToken(
        "addCard",
        data,
        admin_panel_user,
        logout
      );

      if (response.data.code === 200) {
        // setTimeout(getData, 2000);
        // handleSnakbarOpen(response.data.message, "success");
        // handleClose();
        setTimeout(function () {
          getCardList();
          handleSnakbarOpen(response.data.message, "success");
          // clearForm();
          handleAddCardClose();
          // handleClose();
          setLoading(false);
        }, 2000);
      } else {
        handleSnakbarOpen(response.data.message, "error");
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    clearForm();
  }, [handleAddCardClose]);

  return (
    <div>
      <Grid container>
        <Grid item xs={6}>
          <div className={classes.flipCard} onClick={handleCardClick}>
            <div
              className={classes.flipCardInner}
              style={{
                transform: isFlipped ? "rotateY(-180deg)" : "rotateY(0deg)",
              }}
            >
              <div className={classes.flipCardFront}>
                {/* Content for the front side of the card */}

                <img
                  src="/images/chip.svg"
                  alt="logo"
                  style={{
                    position: "absolute",
                    left: "28px",
                    top: "50px",
                    width: "70px",
                  }}
                />
                <div
                  style={{
                    position: "absolute",

                    left: "28px",
                    top: "140px",
                  }}
                >
                  <Typography
                    variant="small"
                    color="#fff"
                    sx={{
                      fontWeight: 400,
                      marginBottom: "-6px",
                      fontFamily: "'Space Mono', monospace",
                    }}
                  >
                    card number
                  </Typography>
                  <Typography
                    variant="h3"
                    color="#fff"
                    sx={{
                      // fontSize: "18px",
                      fontWeight: 400,
                      fontFamily: "'Space Mono', monospace",
                    }}
                  >
                    {cardNo.length > 0
                      ? formatCardNumber()
                      : "0000 0000 0000 0000"}
                  </Typography>
                </div>
                <div
                  style={{
                    position: "absolute",
                    // paddingLeft: "28px",
                    // paddingTop: "200px",
                    left: "28px",
                    top: "225px",
                    width: "444px",
                  }}
                >
                  <Grid container>
                    <Grid item xs={8}>
                      {" "}
                      <Typography
                        variant="small"
                        color="#fff"
                        sx={{
                          fontWeight: 400,
                          marginBottom: "-6px",
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        card holder name
                      </Typography>
                      <Typography
                        variant="h6"
                        color="#fff"
                        sx={{
                          // fontSize: "18px",
                          fontWeight: 400,
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        {cardHolderName ? cardHolderName : "your name"}
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="small"
                        color="#fff"
                        sx={{
                          fontWeight: 400,
                          marginBottom: "-6px",
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        expiration
                      </Typography>
                      <Typography
                        variant="h6"
                        color="#fff"
                        sx={{
                          // fontSize: "18px",
                          fontWeight: 400,
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        {date === null
                          ? "00/00"
                          : dayjs(date).format("MM/YYYY")}
                      </Typography>
                    </Grid>
                  </Grid>
                </div>
              </div>
              <div className={classes.flipCardBack}>
                {/* Content for the back side of the card */}
                <div
                  style={{
                    position: "absolute",
                    // left: "28px",
                    top: "40px",
                    background: "#000",
                    width: "500px",
                    height: "45px",
                  }}
                ></div>

                <Grid
                  container
                  alignItems="center"
                  style={{
                    position: "absolute",

                    left: "28px",
                    top: "120px",
                    background: "#65709f",
                    width: "444px",
                    height: "45px",
                    borderRadius: "8px",
                  }}
                >
                  <Grid
                    item
                    xs={10}
                    style={{
                      background: "#4c5477",
                      height: "100%",
                      borderRadius: "8px 0px 0px 8px",
                    }}
                  >
                    <Typography
                      variant="h4"
                      color="#fff"
                      sx={{
                        // fontSize: "18px",
                        marginLeft: "20px",
                        fontWeight: 400,
                        fontFamily: "'Freehand', cursive",
                      }}
                    >
                      {cardHolderName}
                    </Typography>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      color="#fff"
                      sx={{
                        // fontSize: "18px",
                        fontWeight: 400,
                        fontFamily: "'Space Mono', monospace",
                      }}
                    >
                      {cardCVC.length > 0 ? formatCardCVCNumber() : "000"}
                    </Typography>
                  </Grid>
                </Grid>
                {/* <div
                  style={{
                    position: "absolute",
                    // paddingLeft: "28px",
                    // paddingTop: "200px",
                    left: "28px",
                    top: "225px",
                    width: "444px",
                  }}
                >
                  <Grid container>
                    <Grid item xs={8}>
                      {" "}
                      <Typography
                        variant="small"
                        color="#fff"
                        sx={{
                          fontWeight: 400,
                          marginBottom: "-6px",
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        email
                      </Typography>
                      <Typography
                        variant="h6"
                        color="#fff"
                        sx={{
                          // fontSize: "18px",
                          fontWeight: 400,
                          fontFamily: "'Space Mono', monospace",
                        }}
                      >
                        {cardHolderName ? cardHolderName : "your name"}
                      </Typography>
                    </Grid>
                  
                  </Grid>
                </div> */}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={6}>
          <form onSubmit={handleAddNewCard}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="base" color="text.main" gutterBottom>
                  Name
                </Typography>
                <TextField
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  fullWidth
                  inputProps={{ maxLength: 20 }}
                  value={cardHolderName}
                  onChange={(e) => setCardHolderName(e.target.value)}
                  onFocus={() => setIsFlipped(false)}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="base" color="text.main" gutterBottom>
                  Email
                </Typography>
                <TextField
                  type="email"
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={cardHolderEmail}
                  onChange={(e) => setCardHolderEmail(e.target.value)}
                  onFocus={() => setIsFlipped(false)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="base" color="text.main" gutterBottom>
                  Card Number *
                </Typography>
                <TextField
                  required
                  type="number"
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={cardNo}
                  onChange={(e) => {
                    setCardNo(
                      (e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 16))
                    );
                  }}
                  onFocus={() => setIsFlipped(false)}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="base" color="text.main" gutterBottom>
                  Expiration (mm/yy) *
                </Typography>
                {/* <TextField
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={date}
                  onChange={handleDate}
                /> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  {/* <DemoContainer components={["DateField"]}> */}
                  <DateField
                    id="date"
                    required
                    size="small"
                    fullWidth
                    format="MM/YYYY"
                    value={date}
                    onChange={(newValue) => setDate(newValue)}
                    onFocus={() => setIsFlipped(false)}
                  />
                  {/* </DemoContainer> */}
                </LocalizationProvider>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="base" color="text.main" gutterBottom>
                  Security Code *
                </Typography>
                <TextField
                  required
                  type="number"
                  id="outlined-basic"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={cardCVC}
                  onChange={(e) =>
                    setCardCVC(
                      (e.target.value = Math.max(0, parseInt(e.target.value))
                        .toString()
                        .slice(0, 4))
                    )
                  }
                  onFocus={() => setIsFlipped(true)}
                />
              </Grid>
              <Grid item xs={12}>
                {/* <Button color="primary" variant="contained" fullWidth>
                  Add New card
                </Button> */}
                <Button
                  fullWidth
                  variant="contained"
                  color="primary"
                  disableElevation
                  type="submit"
                  disabled={loading}
                  sx={{
                    minHeight: "37px",
                  }}
                >
                  {loading === false && "Add New Card"}
                  <PulseLoader
                    color={theme.palette.success.main}
                    loading={loading}
                    size={10}
                    speedMultiplier={0.5}
                  />{" "}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddCard;
